import { jsx as _jsx } from "react/jsx-runtime";

/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/prefer-hubspot-url-utils */
import { useSelector } from 'react-redux';
import { getLoginUrl } from '../http-login/getLoginUrl';
import imageUrls from '../images/imageUrls';
import { getFallbackOnboardingUrl } from '../signup-completed-redirection/getFallbackOnboardingUrl';
import { Data } from '../signup-data/DATA';
import { getHublet, getIsNewUser } from '../store/app/selectors';
import { getPortalId } from '../store/auth/selectors';
import { getSignupDataValue } from '../store/signup-data/selectors';
import { useTracker } from '../tracking/useTracker';
import { ErrorKey } from './ErrorKey';
import StandardError from './StandardError';

const ManualLoginView = () => {
  const portalId = useSelector(getPortalId);
  const hublet = useSelector(getHublet);
  const email = useSelector(state => getSignupDataValue(state, Data.Email));
  const isNewUser = useSelector(getIsNewUser);
  const errorKey = ErrorKey.LoginFailed;
  const Tracker = useTracker();

  const onClick = () => {
    Tracker.redirect({
      url: 'https://app.hubspot.com/login'
    });
  };

  return /*#__PURE__*/_jsx(StandardError, {
    errorKey: errorKey,
    href: getLoginUrl({
      redirectUrl: getFallbackOnboardingUrl(portalId, hublet, isNewUser),
      email,
      hublet
    }),
    imageURL: imageUrls.door,
    onSentenceWithLinkClick: onClick
  });
};

export default ManualLoginView;